export const mediaFieldTypes = {
    image: 'Image',
    text: 'Text',
    video: 'Video',
};

export const maxMediaFieldSizes = {
    [mediaFieldTypes.image]: 20 * 1024 * 1024, // 20MB
    [mediaFieldTypes.video]: 101 * 1024 * 1024, // 100MB (+ 1MB extra) - used only for Adfound
};